import type { CSSProperties, MouseEvent } from 'react';
import { MODULE_REGISTRY } from './module-registry';
import { navigate, withAppBasePath } from '../nav';

function onClickNav(to: string) {
  return (e: MouseEvent) => {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    navigate(to);
  };
}

export function Dashboard() {
  return (
    <div className="dashboard">
      <h1>Admin Portal</h1>
      <p className="dashboard-sub">Select a module from the sidebar, or jump in here.</p>
      <div className="module-grid">
        {Object.entries(MODULE_REGISTRY).map(([key, mod]) => {
          const to = `/m/${key}`;
          return (
            <a
              key={key}
              href={withAppBasePath(to)}
              onClick={onClickNav(to)}
              className="module-card"
              style={mod.accent ? ({ '--module-accent': mod.accent } as CSSProperties) : undefined}
            >
              <div className="card-accent" />
              <div className="card-title">{mod.name}</div>
              <div className="card-desc">{mod.description}</div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
